import { mergeStyleSets } from '@fluentui/react';
import { getTheme } from '@fluentui/react';

const theme = getTheme();

export const notificationBellStyles = mergeStyleSets({
  bellWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 48,
    height: 48,
    flexShrink: 0,
  },
  badge: {
    position: 'absolute',
    top: 2,
    right: 2,
    minWidth: 16,
    height: 16,
    padding: '0 4px',
    borderRadius: 8,
    backgroundColor: theme.palette.redDark,
    color: theme.palette.white,
    fontSize: 10,
    fontWeight: 600,
    lineHeight: '16px',
    textAlign: 'center',
    pointerEvents: 'none',
  },
  panelBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    padding: '8px 0',
  },
  panelActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0 0 8px 0',
  },
  emptyState: {
    padding: '24px 8px',
    color: theme.palette.neutralSecondary,
    textAlign: 'center',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    padding: '10px 12px',
    borderRadius: 4,
    border: `1px solid ${theme.palette.neutralLighter}`,
    cursor: 'pointer',
    selectors: {
      '&:hover': {
        backgroundColor: theme.palette.neutralLighterAlt,
      },
    },
  },
  itemUnread: {
    borderLeft: `3px solid ${theme.palette.themePrimary}`,
    backgroundColor: theme.palette.themeLighterAlt,
  },
  itemMessage: {
    fontSize: 13,
    color: theme.palette.neutralPrimary,
  },
  itemMeta: {
    fontSize: 11,
    color: theme.palette.neutralSecondary,
  },
});
